import React from 'react';

import {BoxParams} from './Box';

const flatten = (arr:Array<Array<BoxParams>>):Array<BoxParams> => {
  return arr.reduce(function (flat, toFlatten) {
    return flat.concat(toFlatten);
  }, []);
}

type UsedLettersProps = {
  onClick: Function;
  tries: Array<Array<BoxParams>>;
  allLetters: string[];
};

const UsedLetters = ({ allLetters, tries , onClick}:UsedLettersProps) => {
  const onClickLetter = React.useCallback((e) => {
    onClick(e.target.innerText.toLowerCase())
  }, [onClick])

  const greens:string[] = React.useMemo(() => flatten(tries)
    .filter((item) => item.answer === 'PERFECT')
    .map(i => i.letter), [tries]);

  const yellows:string[] = React.useMemo(() => flatten(tries)
    .filter((item) => item.answer === 'WRONG_POS')
    .map(i => i.letter), [tries]);

  const blacks:string[] = React.useMemo(() => flatten(tries)
    .filter((item) => item.answer === 'NO')
    .map(i => i.letter), [tries]);

  const buttons = React.useMemo(() => {
    const rows = allLetters.map((row, rowIndex) => {
      const letters = row.split('').map((l, index) => {
        const classNames = ['letter'];
        const letter = l.toUpperCase();

        if (greens.indexOf(letter) > -1) {
          classNames.push('correct')
        } else if (yellows.indexOf(letter) > -1) {
          classNames.push('correctButWrongPlace')
        } else if (blacks.indexOf(letter) > -1) {
          classNames.push('done')
        }

        return (
          <button
            key={letter}
            className={classNames.join(' ')}
            style={{transitionDelay: `${index*0.1}s`}}
            onClick={onClickLetter}>
            {letter.toUpperCase()}
          </button>
        )
      })

      if (rowIndex === 2) {
        letters.push((
          <div key="backspace" className="letter backspace" onClick={() => {
            onClick('Backspace')
          }}>
            DEL
          </div>
        ))

        letters.unshift((
          <div key="enter" className="letter enter"onClick={() => {
            onClick('Enter')
          }}>
            ENT
          </div>
        ))
      }

      return (
        <div key={row[0]} className="LetterRow">
          {letters}
        </div>
      )
    })
    return rows;
  }, [allLetters, blacks, greens,onClickLetter,onClick,yellows]);


  return (
    <div className="UsedLetters">
      {buttons}
    </div>
  );
}

export default UsedLetters;

